module.exports = __webpack_public_path__ + "static/img/slider1.437d976.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider1.jpeg
// module id = OKia
// module chunks = 1